export default __webpack_public_path__ + "static/media/clarity_list-solid.97dea31a.svg";